import { Link } from '../router.js'
import { ongletsDuModule, type Peut } from '../shell/menu-modele.js'

/**
 * LES ONGLETS D'UN MODULE (03/11/2026) — les fonctions qui vivaient au
 * troisième niveau du menu, désormais en haut de la page du module.
 *
 * Tirés du registre (navigation/site-navigation.ts) avec le filtre du menu :
 * aucune page n'a à les déclarer, et un module sans fonction visible n'en
 * montre aucun. Ce sont de vrais liens : les adresses ne changent pas, une
 * vue (`?vue=…`) reste une vue. Rendus hors de `.lc-route` : changer
 * d'onglet ne rejoue pas l'apparition de la barre.
 */
export function ModuleOnglets(props: { adresse: string; peut: Peut }) {
  const o = ongletsDuModule(props.adresse, props.peut)
  if (!o) return null
  return (
    <nav className="lc-onglets" aria-label={`Fonctions de ${o.module.label}`}>
      <div className="lc-onglets__liste">
        {o.onglets.map((x) => (
          <Link key={x.id} href={x.route} className="lc-onglets__onglet" aria-current={x.actif ? 'page' : undefined}>
            {x.label}
          </Link>
        ))}
      </div>
    </nav>
  )
}
